import script from "./payslip-report.vue?vue&type=script&setup=true&lang=js"
export * from "./payslip-report.vue?vue&type=script&setup=true&lang=js"

import "./payslip-report.vue?vue&type=style&index=0&id=459200c9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-459200c9"]])

export default __exports__